import { useRootStore } from 'stores/RootStore'
import { generatePath, useHistory } from 'react-router-dom'
import { HandbookItemType } from 'types'
import { values } from 'mobx'
import DeleteModal from 'components/NavRightClickMenu/components/DeleteModal/DeleteModal'
import { useModals } from 'almanac-ui/Modal'
import { RECENT_DOCS_PATH } from 'paths'
import { useQueryClient } from 'react-query'
import { useFinderRefresh } from 'screens/Finder/hooks/useFinderRefresh'
import { FolderMenuFile } from 'components/FolderMenu/Types'
import { useCurrentFolderStore } from './stores/useCurrentFolderStore'

interface Props {
  folderKey: string
  almanac_file: FolderMenuFile
}

export const useDeleteProject = ({ folderKey, almanac_file }: Props) => {
  const history = useHistory()
  const queryClient = useQueryClient()
  const refreshFinder = useFinderRefresh()
  const { handbooks: handbooksStore } = useRootStore()
  const { openModal, closeModal } = useModals()
  const { currentFolder } = useCurrentFolderStore()

  const deleteProject = () => {
    const treeItem = values(handbooksStore.items).find(
      (item) => item?.type === HandbookItemType.NestedHandbook && item.data.folder?.key === folderKey,
    )

    openModal(
      DeleteModal,
      {
        files: [{ ...almanac_file, type: 'folder' }],
        onRequest: () => {
          if (treeItem) {
            handbooksStore.removeItem(treeItem.id)
          }

          // Redirect
          if (currentFolder?.ancestor_keys?.includes(folderKey) || currentFolder?.id === folderKey) {
            history.push(generatePath(RECENT_DOCS_PATH, { workspaceId: almanac_file.workspace.id }))
          }
          closeModal()
          queryClient.invalidateQueries(['workspace', almanac_file.workspace.id, 'files'])

          refreshFinder()
        },
      },
      { newStack: true },
    )
  }

  return {
    deleteProject,
  }
}
